







import { GlobeComponentType } from './script'
export default GlobeComponentType
